<div class="ts-image-upload flex flex-row gap-4 justify-start items-center">
  <div
    class="relative rounded-full border border-black-200 bg-black-50 flex justify-center items-center overflow-hidden"
    [ngClass]="bubbleSize"
  >
    <input
      id="ts-image-upload__input"
      type="file"
      class="hidden"
      #fileInput
      [multiple]="false"
      accept="image/jpeg, image/png"
      (change)="imageChanged.emit($event.target.files[0])"
    />
    <ng-container *ngIf="imageUrl; else noImage">
      <img [src]="imageUrl" width="300" height="300" alt="Account logo" />
    </ng-container>
  </div>
  <div class="flex flex-row gap-2 justify-start items-center">
    <ts-button icon="ts_upload-alt" color="accent" type="stroked" (click)="fileInput.click()">Upload</ts-button>
    <ts-button icon="ts_trash-alt" color="accent" type="stroked" (click)="imageRemoved.emit()" [disabled]="!imageUrl">
      Remove
    </ts-button>
  </div>
</div>

<ng-template #noImage>
  <p class="absolute text-black-400 text-3xl">A</p>
</ng-template>
